import React from 'react'
import { ClientDataTable } from '../../ClientDataTable/ClientDataTable'
import { TableLinkStyleProvider } from '../CommonTableCells/TableLinkStyleContext'
import useApiService from '../../../services/api'

interface MenuTableProps {
  chainId?: number
  showLoadingState?: boolean
  showEmptyState?: boolean
  className?: string
}

export function MenuTable({
  chainId,
  showLoadingState = true,
  showEmptyState = true,
  className = '',
}: MenuTableProps) {
  const api = useApiService()
  const { data: menuData, isLoading } = api.useGetChainMenuList(chainId)

  const columns = [
    {
      id: 'name',
      accessorKey: 'name',
      header: 'Item Name',
      size: 150,
    },
    {
      id: 'description',
      accessorKey: 'description',
      header: 'Description',
      size: 200,
    },
    {
      id: 'price',
      accessorKey: 'price',
      header: 'Price',
      size: 100,
    },
  ]

  if (isLoading && showLoadingState) {
    return <div className="text-center py-4">Loading menu...</div>
  }

  if (!menuData || menuData.length === 0) {
    if (showEmptyState) {
      return (
        <div className="text-center py-4 text-muted">
          No menu items available for this chain.
        </div>
      )
    }
    return null
  }

  return (
    <div
      className={`overflow-hidden rounded-lg border border-neutral-200 ${className}`}
    >
      <TableLinkStyleProvider variant="plain">
        <ClientDataTable
          data={menuData}
          columns={columns}
          enableSorting={true}
          enableGlobalSearch={true}
          searchPlaceholder={'Search menu by keywords...'}
        />
      </TableLinkStyleProvider>
    </div>
  )
}
